export const balanceEn = {
  'balance-title': 'Check Your Card',
  'balance-subtitle':
    'To get started, enter your 10 digit Personal Reference Number (PRN) — it’s printed on the back of your card. This helps us securely retrieve your balance and recent transactions.',
  'balance-subtitlegalileo':
    'To get started, enter your 12 digit Personal Reference Number (PRN) — it’s printed on the back of your card. This helps us securely retrieve your balance and recent transactions.',
  'balance-prninputlabel': 'Enter your PRN',
  'balance-prninputplaceholder': 'e.g. 1234567890',
  'balance-prninputplaceholdergalileo': 'e.g. 123456789012',
  'balance-prnhelpertext': 'Whats this?',
  'balance-prndetailtitle': 'What is a Personal Reference Number (PRN)?',
  'balance-prnhelperdetaildescription':
    'A Personal Reference Number (PRN) is a unique code used to verify and secure a gift card. Often located on the back of the card, it may be needed for online purchases, balance inquiries, or customer support. Keeping the PRN private helps protect the card from unauthorized use.',
  'balance-submit_title': 'Check',
  'balance-prninputerrormsg': 'Please enter a valid PRN',
  'balance-prn10lengtherrormsg': 'PRN must be 10 digits',
  'balance-prn12lengtherrormsg': 'PRN must be 12 digits',
  'balance-prnnotfounderrormsg':
    'We couldn’t find a card with that PRN. Please check and try again.',
  'balance-privacydescription':
    'Your privacy and security are our top priorities. Always keep your Personal Reference Number (PRN) confidential to help prevent unauthorized access to your card.',
  'balance-captcha-rejected': 'Captcha verification failed. Please try again.',
  'balance-service-unavailable':
    'Service is temporarily unavailable. Please try again in a few moments.',
};

export const balanceFr = {
  'balance-title': 'Voir votre carte',
  'balance-subtitle':
    'Pour commencer, entrez votre numéro de référence personnel (PRN) — il est imprimé sur le dos de votre carte. Cela nous aide à récupérer votre solde et vos dernières transactions.',
  'balance-subtitlegalileo':
    'Pour commencer, saisissez votre numéro de référence personnel (PRN) à 12 chiffres, imprimé au dos de votre carte. Cela nous permet de récupérer votre solde et vos transactions récentes en toute sécurité',
  'balance-prninputlabel': 'Entrez votre PRN',
  'balance-prninputplaceholder': 'e.g. 123456789012',
  'balance-prninputplaceholdergalileo': 'e.g. 123456789012',
  'balance-prnhelpertext': 'Qu`est-ce que c`est ça?',
  'balance-prndetailtitle':
    'Qu’est-ce qu’un numéro de référant personnel (PRN)?',
  'balance-prnhelperdetaildescription':
    'Un numéro de référence personnel (PRN) est un code unique utilisé pour vérifier et sécuriser une carte-cadeau. Souvent situé au dos de la carte, il peut être nécessaire pour les achats en ligne, les demandes de solde ou le service client. La confidentialité du PRN permet de protéger la carte contre toute utilisation non autorisée.',
  'balance-submit_title': 'Voir',
  'balance-prninputerrormsg': 'Veuillez entrer un PRN valide',
  'balance-prn10lengtherrormsg': 'Le PRN doit comporter 10 chiffres',
  'balance-prn12lengtherrormsg': 'Le PRN doit comporter 12 chiffres',
  'balance-prnnotfounderrormsg':
    'Nous n’avons pas trouvé de carte avec ce PRN. Veuillez vérifier et essayer encore.',
  'balance-privacydescription':
    'Votre privatisation et votre sécurité sont nos priorités. Gardez toujours votre Numéro de Référant Personnel (PRN) confidentiel pour aider a prévenir l’accès non autorisé à votre carte.',
  'balance-captcha-rejected':
    'Échec de la vérification du captcha. Veuillez réessayer.',
  'balance-service-unavailable':
    'Service temporairement indisponible. Veuillez réessayer dans quelques instants.',
};
